<template>
  <div v-if="acc" class="user_wrap">
    <section class="account_hero">
      <div class="hero_background" />
      <div class="hero_content">
        <div class="account_bar">
          <div class="brand_mark"><img :src="profileImage" alt=""></div>
          <div class="account_identity">
            <div class="account_name_line">
              <div class="account_mobile">{{ acc.mobile }}</div>
              <span v-if="acc.vip" class="vip_badge">{{ acc.vip.name }}</span>
            </div>
            <div class="account_meta">
              <span>{{ $t('d.creditscore') }}: {{ acc.credit }}</span>
            </div>
          </div>
          <button type="button" class="setting_button" @click="$router.push('/set')"><van-icon name="setting-o" size="22" /></button>
        </div>

        <div class="balance_card">
          <div class="balance_top">
            <div>
              <p class="balance_label">{{ $t('d.balance') }}</p>
              <p class="balance_amount">{{ 1 * data.money }}</p>
            </div>
            <button type="button" class="recharge_button" @click="$router.push('/invest')"><van-icon name="add" /></button>
          </div>
          <div class="balance_divider" />
          <div class="balance_stats">
            <div class="stat_item"><p>{{ 1 * data.frozenmoney }}</p><span>{{ $t('d.frozen') }}</span></div>
            <div class="stat_item"><p>{{ 1 * data.reward }}</p><span>{{ $t('d.todayrewards') }}</span></div>
          </div>
        </div>
      </div>
    </section>

    <main class="user_content">
      <section class="invite_card">
        <div class="invite_copy"><span>{{ $t('d.code') }}</span><strong>{{ data.yaocode }}</strong></div>
        <button type="button" class="copy_button" @click.stop="copyYaocode">{{ $t('invest_bank.copy') }}</button>
      </section>

      <section class="vip_group">
        <div class="vip_group_txt">{{ $t('pro2.upvip') }}</div>
        <img src="../images/ban3/vip.png" alt="" class="vip_group_img">
      </section>

      <section class="menu_section">
        <van-cell v-for="item in menuItems" :key="item.route" is-link class="menu_item" @click="$router.push(item.route)">
          <template #title>
            <span class="menu_icon"><van-icon :name="item.icon" size="20" /></span>
            <span class="custom-title">{{ $t(item.label) }}</span>
          </template>
        </van-cell>
      </section>

      <button type="button" class="logout_button" @click="logout">{{ $t('safe.signOut') }}</button>
    </main>

    <van-popup v-model="show" round class="notice_popup">{{ msg }}</van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import brandLogo from '../images/forever-link-logo-transparent.png';
import {
  Icon,
  Cell,
  Popup,
} from 'vant';

Vue.use(Cell).use(Icon).use(Popup);

export default {
  name: 'User',
  data() {
    return {
      data: {},
      islogin: false,
      show_kefu: false,
      acc: null,
      msg: null,
      show: false,
      app: null,
      bodyScrollHandler: null,
      documentClickHandler: null,
      menuItems: [
        { route: '/cash', icon: 'share-o', label: 'user.withdraw' },
        { route: '/cashlist', icon: 'certificate', label: 'user.withdrawalRecord' },
        { route: '/funds', icon: 'debit-pay', label: 'pro2.transactionhis' },
        { route: '/order', icon: 'peer-pay', label: 'feng.order' },
      ],
    };
  },
  computed: {
    profileImage() {
      return this.app && this.app.fuli1 ? this.app.fuli1 : brandLogo;
    },
  },
  created() {
    this.$parent.footer('user');
  },
  mounted() {
    this.islogin = localStorage.getItem('token') !== null;
    if (!this.islogin) {
      this.$router.push('/login');
      return;
    }
    this.start();
    this.bodyScrollHandler = this.handleBodyScroll.bind(this);
    this.documentClickHandler = this.handleDocumentClick.bind(this);
    document.body.addEventListener('scroll', this.bodyScrollHandler, false);
    document.addEventListener('click', this.documentClickHandler, false);
  },
  beforeDestroy() {
    if (this.bodyScrollHandler) {
      document.body.removeEventListener('scroll', this.bodyScrollHandler, false);
    }
    if (this.documentClickHandler) {
      document.removeEventListener('click', this.documentClickHandler, false);
    }
  },
  methods: {
    handleBodyScroll() {
      if (this.show_kefu) {
        this.show_kefu = false;
      }
    },
    handleDocumentClick(event) {
      if (event.target.className !== 'kefu_img') {
        this.show_kefu = false;
      }
    },
    sync() {
      Fetch('/index/sync', {}, null, false).then((r) => {
        const notices = r.data;
        if (notices && notices.length > 0) {
          this.msg = notices[0].content;
          this.show = true;
          setTimeout(() => {
            Fetch('/user/notice_view', { id: notices[0].id });
          }, 2000);
        }
      });
    },
    copy() {
      this.$toast({ background: '#063942', message: this.$t('invest_qrcode.copySucceeded') });
    },
    copyYaocode() {
      const yaocode = this.data && this.data.yaocode;
      this.copyText(yaocode === undefined || yaocode === null ? '' : String(yaocode));
    },
    copyText(text) {
      if (!text) return;
      if (this.copyTextBySelection(text)) {
        this.copy();
        return;
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => this.copy()).catch(() => {});
      }
    },
    copyTextBySelection(text) {
      const input = document.createElement('textarea');
      input.value = text;
      input.setAttribute('readonly', 'readonly');
      input.style.position = 'fixed';
      input.style.left = '-9999px';
      input.style.top = '0';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.focus();
      input.select();
      input.setSelectionRange(0, input.value.length);
      let copied = false;
      try {
        copied = document.execCommand('copy');
      } catch (error) {
        copied = false;
      }
      document.body.removeChild(input);
      return copied;
    },
    start() {
      Fetch('/index/webconfig').then((r) => {
        this.app = r.data;
      });
      Fetch('/user/info').then((r) => {
        this.data = r.data;
        this.acc = r.data;
      });
      setTimeout(() => this.sync(), 2000);
    },
    logout() {
      localStorage.removeItem('token');
      this.$router.replace('/');
    },
  },
};
</script>

<style lang="less" scoped>
.user_wrap { min-height: 100vh; background: #f1f8f7; color: #123d42; }
.account_hero { position: relative; min-height: 286px; overflow: hidden; background: #073b43; }
.hero_background { position: absolute; inset: 0; background-image: linear-gradient(90deg, rgba(4, 48, 56, .98) 0%, rgba(5, 66, 75, .9) 48%, rgba(5, 63, 72, .38) 100%), url('../images/tawkify-fine-dining-hero.jpg'); background-repeat: no-repeat; background-position: center, 76% 47%; background-size: 100% 100%, auto 210%; }
.hero_content { position: relative; z-index: 1; padding: 19px 18px 0; }
.account_bar, .balance_top, .balance_stats, .invite_card, .vip_group { display: flex; align-items: center; justify-content: space-between; }
.brand_mark { display: flex; width: 60px; height: 60px; align-items: center; justify-content: center; overflow: hidden; border: 2px solid #80d4d0; border-radius: 50%; background: #e6f5f3; box-shadow: 0 0 0 4px rgba(255, 255, 255, .13), 0 8px 18px rgba(0, 21, 27, .26); }
.brand_mark img { width: 100%; height: 100%; object-fit: cover; }
.account_identity { min-width: 0; flex: 1; margin-left: 11px; }
.account_name_line { display: flex; min-width: 0; align-items: center; gap: 7px; }
.account_mobile { min-width: 0; overflow: hidden; color: #fff; font-size: 16px; font-weight: 700; line-height: 23px; text-overflow: ellipsis; white-space: nowrap; }
.account_meta { display: flex; align-items: center; gap: 7px; margin-top: 3px; color: #d3edeb; font-size: 12px; line-height: 20px; }
.vip_badge { display: inline-flex; max-width: 100px; flex: 0 0 auto; align-items: center; overflow: hidden; padding: 3px 8px; border: 1px solid #e8c982; border-radius: 10px; background: #fff4d4; color: #6c4c19; font-size: 12px; font-weight: 700; line-height: 15px; text-overflow: ellipsis; white-space: nowrap; }
.setting_button, .recharge_button, .copy_button, .logout_button { border: 0; font: inherit; }
.setting_button { display: flex; width: 39px; height: 39px; align-items: center; justify-content: center; border: 1px solid rgba(201, 242, 238, .82); border-radius: 50%; background: rgba(255, 255, 255, .12); box-shadow: 0 5px 12px rgba(0, 20, 28, .2); color: #e3fbf8; }
.balance_card { margin-top: 22px; padding: 17px 16px 14px; border: 1px solid rgba(255, 255, 255, .76); border-radius: 17px; background: rgba(255, 255, 255, .95); box-shadow: 0 15px 28px rgba(0, 28, 35, .24), inset 0 1px 0 #fff; backdrop-filter: blur(7px); }
.balance_label, .balance_amount, .stat_item p, .stat_item span { margin: 0; }
.balance_label { color: #5b7476; font-size: 12px; }
.balance_amount { margin-top: 4px; color: #073b43; font-size: 18px; font-weight: 700; line-height: 26px; letter-spacing: .3px; }
.recharge_button { display: flex; width: 41px; height: 41px; align-items: center; justify-content: center; border: 1px solid #087780; border-radius: 50%; background: #0d8d94; box-shadow: 0 5px 14px rgba(4, 81, 89, .25); color: #fff; font-size: 25px; }
.balance_divider { height: 1px; margin: 13px 0 11px; background: #deebea; }
.balance_stats { gap: 12px; }
.stat_item { min-width: 0; flex: 1; }
.stat_item + .stat_item { padding-left: 14px; border-left: 1px solid #dcebea; }
.stat_item p { overflow: hidden; color: #075963; font-size: 16px; font-weight: 700; line-height: 23px; text-overflow: ellipsis; white-space: nowrap; }
.stat_item span { display: block; overflow: hidden; margin-top: 2px; color: #71898b; font-size: 12px; text-overflow: ellipsis; white-space: nowrap; }
.user_content { padding: 18px 14px 88px; background: linear-gradient(180deg, #f3f9f8 0%, #ebf5f3 100%); }
.invite_card { min-height: 60px; padding: 0 14px 0 16px; border: 1px solid #c7e0dd; border-radius: 14px; background: rgba(255, 255, 255, .94); box-shadow: 0 8px 17px rgba(10, 73, 79, .08); }
.invite_copy { min-width: 0; }
.invite_copy span, .invite_copy strong { display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.invite_copy span { color: #60797c; font-size: 12px; }
.invite_copy strong { margin-top: 2px; color: #074b53; font-size: 16px; font-weight: 700; }
.copy_button { flex: 0 0 auto; margin-left: 15px; padding: 8px 15px; border: 1px solid #15909a; border-radius: 17px; background: #f4fbfa; color: #08636c; font-size: 12px; }
.vip_group { position: relative; min-height: 84px; margin-top: 14px; padding: 10px 14px 10px 19px; overflow: hidden; border: 1px solid #075e67; border-radius: 15px; background: linear-gradient(115deg, #063942 0%, #075a62 58%, #0c8188 100%); box-shadow: 0 10px 20px rgba(10, 71, 77, .16), inset 0 1px 0 rgba(255, 255, 255, .16); }
.vip_group::before { position: absolute; top: 13px; bottom: 13px; left: 0; width: 4px; border-radius: 0 4px 4px 0; background: #71d2cc; content: ''; }
.vip_group_txt { position: relative; z-index: 1; min-width: 0; flex: 1; padding-right: 9px; color: #f4fffe; font-size: 14px; font-weight: 600; line-height: 19px; }
.vip_group_img { position: relative; z-index: 1; width: 86px; max-height: 72px; object-fit: contain; filter: brightness(0) invert(1) opacity(.48); }
.menu_section { margin-top: 16px; }
/deep/ .menu_item.van-cell { display: flex; align-items: center; min-height: 57px; margin-bottom: 10px; padding: 10px 14px; border: 1px solid #c9e1de; border-radius: 14px; background: rgba(255, 255, 255, .95); box-shadow: 0 8px 16px rgba(12, 75, 79, .07), inset 0 1px 0 #fff; color: #123d42; }
/deep/ .menu_item.van-cell:active { background: #e4f3f1; }
/deep/ .menu_item .van-cell__title { display: flex; min-width: 0; align-items: center; }
/deep/ .menu_item .van-cell__right-icon { margin-left: 10px; color: #0b7d85; font-size: 17px; }
.menu_icon { display: flex; width: 33px; height: 33px; align-items: center; justify-content: center; margin-right: 12px; border: 1px solid #a8d5d0; border-radius: 10px; background: #e8f5f3; color: #08646d; }
.custom-title { overflow: hidden; color: #173f44; font-size: 14px; font-weight: 600; text-overflow: ellipsis; white-space: nowrap; }
.logout_button { display: block; width: 100%; min-height: 50px; margin-top: 38px; border: 1px solid #0c7b83; border-radius: 14px; background: #073f47; color: #fff; font-size: 14px; font-weight: 600; letter-spacing: .4px; box-shadow: 0 8px 16px rgba(11, 70, 76, .14); }
.logout_button:active, .copy_button:active, .setting_button:active, .recharge_button:active { opacity: .78; }
.notice_popup { width: 70%; padding: 15px; border: 1px solid #73c9c4; background: #063942; color: #eafffc; font-weight: 600; line-height: 30px; }
@media (max-width: 340px) { .hero_content { padding-right: 12px; padding-left: 12px; } .balance_card { padding-right: 13px; padding-left: 13px; } .account_meta { gap: 4px; } .user_content { padding-right: 10px; padding-left: 10px; } .vip_group { padding-right: 13px; padding-left: 13px; } }
</style>
